// @flow
import axios from 'axios';

export const sendRequest = (url: string, params: Object): Promise =>
  axios(url, params);
